export default __webpack_public_path__ + "media/images/linkedin-alt-c78975af436d4b630ee74a12c11e8b89.svg";